import React, { useState, useEffect } from "react";
import { Input, Form } from "antd";
import { StandaloneSearchBox } from "@react-google-maps/api";
import { CloseCircleFilled } from "@ant-design/icons";
import validations from "../../utils/validations";
import FloatingField from "../common/FloatingField";

const GoogleMapsInput = ({
  form,
  setLatLng,
  direction,
  latLng,
  field,
  placeholder,
  setCity,
  city,
  showLabel = true,
  label,
  required = true,
  floatingLabel = false,
}) => {
  const [autocomplete, setAutocomplete] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const fieldValue = Form.useWatch(field, form);

  const handlePlacesChanged = () => {
    console.log("change", direction);
    if (autocomplete) {
      const places = autocomplete.getPlaces();
      if (places.length > 0) {
        const selectedPlace = places[0];
        const lat = selectedPlace.geometry.location.lat();
        const lng = selectedPlace.geometry.location.lng();

        if (selectedPlace.address_components) {
          const countryComponent = selectedPlace.address_components.find(
            (component) => component.types.includes("country"),
          );

          console.log("countryComponent", countryComponent);
          if (countryComponent) {
            form.setFieldsValue({
              [`${direction}_country_code`]: countryComponent.short_name,
            });
            form.setFieldsValue({
              [`${direction}_country`]: countryComponent.long_name,
            });
          }

          form.setFieldsValue({ [field]: selectedPlace.formatted_address });

          setLatLng({
            ...latLng,
            [direction]: { lat, lng },
          });
          if (city) {
            setCity({
              ...city,
              [direction]: selectedPlace.name,
            });
          }
        }
      }
    }
  };

  const onLoad = (ref) => {
    setAutocomplete(ref);
  };

  // Update local state when form value changes
  useEffect(() => {
    const currentValue = form.getFieldValue(field);
    console.log("currentValue", currentValue);
    if (currentValue !== undefined) {
      setInputValue(currentValue);
    }
  }, [form, field, fieldValue]);

  // Clear input value and reset coordinates
  const handleClear = (e) => {
    e.stopPropagation();
    form.setFieldsValue({ [field]: "" });
    setInputValue("");
    setLatLng({
      ...latLng,
      [direction]: {},
    });
    if (city) {
      setCity({
        ...city,
        [direction]: "",
      });
    }
  };

  const input = (
    <Input
      placeholder={floatingLabel ? "" : placeholder}
      size="large"
      onChange={(e) => setInputValue(e.target.value)}
      suffix={
        inputValue ? (
          <CloseCircleFilled
            style={{
              color: "rgba(0,0,0,.45)",
              cursor: "pointer",
              visibility: inputValue ? "visible" : "hidden",
            }}
            onClick={inputValue ? handleClear : undefined}
          />
        ) : (
          " "
        )
      }
    />
  );

  return (
    <StandaloneSearchBox onLoad={onLoad} onPlacesChanged={handlePlacesChanged}>
      <div className="google-places-wrapper">
        {field.includes("from") && (
          <div className="places-item-form places-item-form--from">A</div>
        )}
        {field.includes("to") && (
          <div className="places-item-form places-item-form--to">B</div>
        )}
        <Form.Item
          label={
            floatingLabel
              ? " "
              : showLabel
              ? label
                ? label
                : field.includes("from")
                  ? "Откуда"
                  : "Куда"
              : " "
          }
          name={field}
          rules={required ? [validations.required] : []}
        >
          {floatingLabel ? (
            <FloatingField
              label={placeholder}
              active={inputValue}
              className="floating-field--place"
            >
              {input}
            </FloatingField>
          ) : (
            input
          )}
        </Form.Item>
      </div>
    </StandaloneSearchBox>
  );
};

export default GoogleMapsInput;
